import * as React from 'react'
import { DotDotDotWidget } from './DotDotDotWidget'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const DotDotDotWidgetExamples = () => {
  return (
    <div className="DotDotDotWidgetExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <DotDotDotWidget />
      </Provider>
    </div>
  )
}
